import React, {useState,useEffect} from 'react'
import './OrderingCardsGame.css'
import Card1 from './Cards/1.png'
import Card2 from './Cards/2.png'
import Card3 from './Cards/3.png'
import Card4 from './Cards/4.png'
import Card5 from './Cards/5.png'
import Card6 from './Cards/6.png'
import Card7 from './Cards/7.png'
import Card8 from './Cards/8.png'
import Card9 from './Cards/9.png'

const OrderingCardsGame = () => {
    const [T, setT] = useState([{
        Value: 1,
        Card : Card1
    },{
        Value: 2,
        Card : Card2
    },{
        Value: 3,
        Card : Card3
    },{
        Value: 4,
        Card : Card4
    },{
        Value: 5,
        Card : Card5
    }
    ,{
        Value: 6,
        Card : Card6
    },
    {
        Value: 7,
        Card : Card7
    },{
        Value: 8,
        Card : Card8
    },{
        Value: 9,
        Card : Card9
    }
])
const [isWin, setIsWin] = useState(false);
    const shuffleArray = (arr) => {
        let T = [...arr]; // copy

        for (let i = T.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [T[i], T[j]] = [T[j], T[i]];
        }

        return T;
    }
    const Decreasing = (arr,n)=>{
        let T=[...arr]
        for (let i = 0; i < n+1; i++) {
            const X = T[i];
            var j=i-1
            while (j>-1 && X.Value>T[j].Value) {
                T[j+1]=T[j]
                j-=1
            }
            T[j+1]=X

            
        }
        return T
    }
    const Palyndrom = (arr)=>{
        let T=[...arr]
        for (let index = 0; index < T.length / 2+1; index++) {
            var x = T[index];
            T[index]=T[T.length -index-1]
            T[T.length -index-1]=x 
        }
        return T
    }
    const isIncreasing = (arr) => {
        for (let i = 0; i < arr.length - 1; i++) {
            if (arr[i].Value > arr[i + 1].Value) {
                return false;
            }
        }
        return true;
    }

    useEffect(() => {
        setT(prev => shuffleArray(prev));
    }, []);
    useEffect(() => {
        if (isIncreasing(T)) {
            setIsWin(true);
        } else {
            setIsWin(false);
        }
    }, [T]);
    
  return (
    <div className='OrderingCardsGame-container'>
        <h1>+ Don't bother looking for cards, here are some ;) +</h1>
        <div className='Cards-container'>{T.map((el)=>(
            <img src={el.Card} alt=""  />
        ))}</div>
        {isWin===true? <p>Well Done !</p>:null}
        
<div className='Buttons-container'>

        <button onClick={()=>{setT(Palyndrom(T))}}>First Move</button>
        <button onClick={()=>{setT(Decreasing(T,T[0].Value-1))}}>Second Move</button>

</div>

    </div>
  )
}

export default OrderingCardsGame